var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('boolean-setter',_vm._g(_vm._b({attrs:{"booleans":_vm.booleans}},'boolean-setter',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }